/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ month: NonNullable<unknown> }} My_Grower_Report_This_MonthInputs */

const vi_my_grower_report_this_month = /** @type {(inputs: My_Grower_Report_This_MonthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tháng này (${i?.month})`)
};

/**

* @param {My_Grower_Report_This_MonthInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const my_grower_report_this_month = /** @type {((inputs: My_Grower_Report_This_MonthInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Grower_Report_This_MonthInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_my_grower_report_this_month(inputs)
});